module.exports = __webpack_public_path__ + "static/media/still-cgi.cdacdd7e.jpg";